var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKpLb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.7 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.5,7.2C105.7,2.4,100,0,93.3,0h-40v80h17.6v-19.7c-6.7,0-12.1-5.4-12.1-12.1s5.4-12.1,12.1-12.1,12.1,5.4,12.1,12.1,0,.4,0,.6h10.4c6.7,0,12.5-2.4,17.2-7.2,4.8-4.8,7.2-10.5,7.2-17.3s-2.4-12.5-7.2-17.3h0v.2s0,0-.1,0ZM96.6,29.3c-1.4,1.4-3,2-4.9,2h-19.3v-13.7h19.3c1.9,0,3.5.7,4.9,2s2.1,3,2.1,4.8-.7,3.5-2.1,4.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79,48.9c-.3,4.3-3.8,7.6-8.2,7.6s-8.2-3.7-8.2-8.2,3.7-8.2,8.2-8.2,8.2,3.7,8.2,8.2,0,.4,0,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,48.2v.6c-.3,4.3-3.8,7.6-8.2,7.6s-8.2-3.7-8.2-8.2,3.7-8.2,8.2-8.2,8.2,3.7,8.2,8.2h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.4,44.7c0,6.7,5.4,12.1,12.1,12.1s.7,0,1,0v23.3H0V0h17.5v32.6h-1c-6.7,0-12.1,5.4-12.1,12.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,40l27.1,40h-19.8l-16.3-25c3.5-2.1,5.8-5.9,5.8-10.3s-4.8-11.4-10.9-12L41.6,0h20.6l-30.3,40s-.1,0,0,0c0,0-.1,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.7,51.8c-1,.6-2,.9-3.2,1.1h-1c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2,8.2,3.7,8.2,8.2-1.6,5.6-4,7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7,44.7c0,3-1.6,5.6-4,7.1-1,.6-2,.9-3.2,1.1h-1c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2,8.2,3.7,8.2,8.2h0Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpLb);
export default __webpack_public_path__ + "static/media/KP-LB.1aa154e29ea8bcd9b742796ef3d69b7e.svg";
export { ForwardRef as ReactComponent };